// Per-workorder log of a generated batch, opened from the recap banner on the
// workorders list. Same table and shell as the chained-generation wizard.
import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['overlay', 'body']

  open() {
    this.overlayTarget.hidden = false
    if (this.loaded) return

    this.bodyTarget.innerHTML =
      `<tr class="genchain__report-loading"><td colspan="5"><span class="genchain__spinner"></span></td></tr>`
    const timestamp = this.data.get('timestamp')
    fetch(`/maintenance/workorders/generation_report?timestamp=${timestamp}`, {
      credentials: 'same-origin',
      headers:     { 'Accept': 'application/json' },
    })
      .then(res => res.json())
      .then(json => {
        this.loaded = true
        this.bodyTarget.innerHTML = ''
        json.rows.forEach(row => {
          const tr = document.createElement('tr')
          const cells = [
            `<td><b>${row.code}</b> ${row.title}</td>`,
            `<td>${row.date}</td>`,
            `<td>${row.technician}</td>`,
          ]
          if (row.optimize)    cells.push(`<td class="is-${row.optimize.state}">${row.optimize.label}</td>`)
          if (row.appointment) cells.push(`<td class="is-${row.appointment.state}">${row.appointment.label}</td>`)
          tr.innerHTML = cells.join('')
          this.bodyTarget.appendChild(tr)
        })
      })
      .catch(() => { this.bodyTarget.innerHTML = '' })
  }

  close() {
    this.overlayTarget.hidden = true
  }
}
